
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { FormValues } from "./useAppointmentForm";

interface AppointmentFormFieldsProps {
  form: UseFormReturn<FormValues>;
}

export const AppointmentFormFields = ({ form }: AppointmentFormFieldsProps) => {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="doctor_name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Nom du médecin</FormLabel>
            <FormControl>
              <Input required placeholder="Dr. Dupont" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="specialty"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Spécialité</FormLabel>
            <FormControl>
              <Input placeholder="Ex: Cardiologue" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="location"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Lieu</FormLabel>
            <FormControl>
              <Input required placeholder="Adresse du cabinet" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="date"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Date et heure</FormLabel>
            <FormControl>
              <Input required type="datetime-local" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="duration"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Durée prévue</FormLabel>
            <FormControl>
              <Input placeholder="Ex: 30 minutes" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="reason"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Motif de la consultation</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Décrivez la raison de votre visite"
                className="min-h-[80px]"
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="insurance_info"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Informations d'assurance</FormLabel>
            <FormControl>
              <Input placeholder="Numéro de sécurité sociale, mutuelle..." {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="documents_required"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Documents à apporter</FormLabel>
            <FormControl>
              <Input placeholder="Ex: Carte vitale, ordonnances..." {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Notes additionnelles</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Autres informations importantes..."
                className="min-h-[80px]"
                {...field} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
